import Dialog from 'src/componentes/dialog';
import PerdaOperacionalView from './PerdaOperacionalListView';
import { useRef, useState } from 'react';
import { useIntl } from 'react-intl';
import Button from 'src/componentes/button';
import { capitalizeFirstLetter } from 'src/utils/string';
import useAuth from 'src/hooks/useAuth';

const PerdaOperacionalListViewModal = ({ selectedCallback = {}, ...rest }) => {
  const modalRef = useRef();
  const intl = useIntl();
  const [selecteds, setSelecteds] = useState([]);
  const { terms: resources } = useAuth();

  const handleClose = () => {
    modalRef.current.close();
  };

  const handleConfirm = () => {
    selectedCallback && selectedCallback(selecteds);
    modalRef.current.close();
  };

  const actions = [
    <Button key={1} onClick={handleClose} color="secondary">
      {intl.formatMessage({ id: 'label.cancelar' })}
    </Button>,
    <Button className="pl-2" key={2} onClick={handleConfirm} color="primary">
      {intl.formatMessage({ id: 'label.confirmar' })}
    </Button>,
  ];

  const onSelect = (newList) => {
    setSelecteds(newList);
  };

  return (
    <Dialog
      {...rest}
      title={capitalizeFirstLetter(resources.perdasoperacionais)}
      width="80%"
      maxHeight="70%"
      actions={actions}
      padContent
      onRequestClose={handleClose}
      ref={modalRef}
    >
      <PerdaOperacionalView select onSelect={onSelect} multiple {...rest} />
    </Dialog>
  );
};

export default PerdaOperacionalListViewModal;
